import clsx from 'clsx'
import { rem } from 'polished'
import { forwardRef } from 'react'
import * as React from 'react'
import styled from 'styled-components'

import Clickable from 'components/Common/Clickable'
import BodyText from 'LuxKit/Typography/BodyText'
import Caption from 'LuxKit/Typography/Caption'
import { mediaQueryUp } from 'components/utils/breakpoint'

const DateScrollMenuItem = styled(Clickable)`
  padding: ${rem(8)} ${rem(4)};
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  text-overflow: ellipsis;

  ${mediaQueryUp.tablet} {
    padding: ${rem(16)} ${rem(4)};
  }
`

const DateAndDayContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: ${(props) => props.theme.borderRadius.S};
  padding: ${rem(8)} ${rem(12)};
  background-color: transparent;

  &.selected {
    background-color: ${(props) => props.theme.palette.neutral.default.six};
  }

  & > * + * {
    margin-top: ${rem(4)};
  }
`

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  selected: boolean
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
  /** Required by ScrollMenu to track the items */
  id: string
  mainLabel: React.ReactNode
  subLabel: React.ReactNode
}

const DateItem = forwardRef<HTMLButtonElement, Props>(({ mainLabel, subLabel, selected, onClick, id, ...rest }, ref) => {
  return (
    <DateScrollMenuItem onClick={onClick} id={id} ref={ref} {...rest}>
      <DateAndDayContainer className={clsx({ selected })}>
        <BodyText
          variant="large"
          weight={selected ? 'bold' : 'normal'}
          wrap="no-wrap"
          colour={selected ? 'neutral-one' : undefined}
        >
          {mainLabel}
        </BodyText>
        <Caption
          variant="large"
          wrap="no-wrap"
          colour={selected ? 'neutral-one' : 'neutral-three'}
        >
          {subLabel}
        </Caption>
      </DateAndDayContainer>
    </DateScrollMenuItem>
  )
})

export default DateItem
